var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdoptedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.74609,
    y: 4.12305,
    width: 30.4771,
    height: 30.4771,
    fill: "white",
    stroke: "#0E0F10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24609 1L0.999915 1L0.999915 37.7233L6.24609 37.7233",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7231 1L42.9693 1L42.9693 37.7233L37.7231 37.7233",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdoptedIn);
export default __webpack_public_path__ + "static/media/adopted-in.565de33fb77149a2f0473d40817ab733.svg";
export { ForwardRef as ReactComponent };